// extracted by mini-css-extract-plugin
export default {"cls1":"En10HyoBfGZkirP7H1hF","cls2":"QdC7XFnSiX0FeLryE_Mf En10HyoBfGZkirP7H1hF"};